import request from "@/plugins/axios.js";

const getDetail = data => {
  return request({
    url: "/Zphd/queryZphdnr",
    method: "post",
    data
  });
};
const downloadFj = data => {
  // return request({
  //   url: "/Zphd/downLoadFile",
  //   method: "post",
  //   data
  // });
  return request.post("/Zphd/downLoadFile", data, {
    responseType: "arraybuffer"
  });
};
export default {
  getDetail,
  downloadFj
};
